export const CO_GET_PRODUCTCATEGORY_LISTING = "CO_GET_PRODUCTCATEGORY_LISTING"
export const CO_GET_PRODUCTCATEGORY_LISTING_SUCCESS = "CO_GET_PRODUCTCATEGORY_LISTING_SUCCESS"
export const CO_GET_PRODUCTCATEGORY_LISTING_FAILED = "CO_GET_PRODUCTCATEGORY_LISTING_FAILED"